
import { Component, Vue, Watch } from 'vue-property-decorator'
import { apiShopDetail, apiShopAdd, apiShopEdit, apiSetMealLists } from '@/api/shop'
import historyMeal from './components/history-meal.vue'
import { debounce } from '@/utils/util'
import lsPagination from '@/components/ls-pagination.vue'
import ExportData from '@/components/export-data/index.vue'
import LsDialog from '@/components/ls-dialog.vue'

@Component({
  components: {
    historyMeal
  }
})
export default class ListsDetail extends Vue {
  /** S Data **/

  identity: number | null = null; // ข้อมูลประจำตัวของผู้ใช้การแก้ไขปัจจุบันID

  setMealData: any = []

  // เพิ่มข้อมูลแบบฟอร์มร้านค้า
  form: any = {
    name: '', // ชื่อ
    super_admin: '', // บัญชี
    super_password: '', // รหัสผ่าน
    super_password_confirm: '', // ยืนยันรหัสผ่าน
    status: 1, // สถานะร้านค้า 0-หยุดให้บริการ 1-เริ่มให้บริการ
    contact: '', // ผู้ติดต่อ
    contact_mobile: '', // หมายเลขโทรศัพท์ติดต่อ
    domain_alias: '', // นามแฝงชื่อโดเมน
    is_check_domain: 1, // ไม่ว่าจะยืนยันชื่อโดเมน
    shop_url: '', // ชื่อโดเมนปัจจุบัน
    set_meal_id: '', // คอมโบID
    expires_time: '', // เวลาหมดอายุ
    remark: '', // หมายเหตุ
    shop_data: {}
  };

  // การตรวจสอบแบบฟอร์ม
  rules = {
    name: [{ required: true, message: 'กรุณากรอกชื่อร้านค้า', trigger: 'blur' }],
    super_admin: [
      { required: true, message: 'กรุณากรอกชื่อร้านค้า', trigger: 'blur' }
    ],
    super_password: [
      { required: true, message: 'กรุณากรอกรหัสผ่าน', trigger: 'blur' },
      {
        validator: (rule: object, value: string, callback: any) => {
          !value ? callback(new Error('กรุณากรอกรหัสผ่าน')) : callback()
        },
        trigger: 'blur'
      }
    ],
    super_password_confirm: [
      { required: true, message: 'กรุณากรอกรหัสผ่านอีกครั้ง', trigger: 'blur' },
      {
        validator: (rule: object, value: string, callback: any) => {
          if (this.form.password) {
            if (!value) callback(new Error('กรุณากรอกรหัสผ่านอีกครั้ง'))
            if (value !== this.form.password) { callback(new Error('รหัสผ่านที่ป้อนสองครั้งไม่สอดคล้องกัน!')) }
          }
          callback()
        },
        trigger: 'blur'
      }
    ],
    set_meal_id: [{ required: true, message: 'กรุณาเลือกแพ็คเกจ', trigger: ['blur', 'change'] }],
    expires_time: [{ required: true, message: 'กรุณาเลือกเวลาหมดอายุ', trigger: ['blur', 'change'] }]
  };

  /** E Data **/

  /** S Methods **/
  // คลิกเพื่อส่งแบบฟอร์ม
  onSubmit(formName: string) {
    // ตรวจสอบว่ารูปแบบแบบฟอร์มถูกต้อง
    const refs = this.$refs[formName] as HTMLFormElement
    refs.validate((valid: boolean): any => {
      if (!valid) return

      if (!this.identity) {
        this.handleShopAdd()
      } else {
        this.handleShopEdit()
      }
    })
  }

  // เพิ่มร้านค้า
  async handleShopAdd(): Promise<void> {
    await apiShopAdd({ ...this.form })
    setTimeout(() => this.$router.go(-1), 500)
  }

  // แก้ไขร้านค้า
  async handleShopEdit(): Promise<void> {
    await apiShopEdit({ ...this.form, id: this.identity })
    setTimeout(() => this.$router.go(-1), 500)
  }

  // รับรายละเอียด
  async getShopDetailFunc(): Promise<void> {
    const res: any = await apiShopDetail({
      id: this.identity as number
    })
    Object.keys(res).map((key) => {
      this.$set(this.form, key, res[key])
    })
  }

  // รับรายการแพ็คเกจ
  async getSetMealLists(): Promise<void> {
    const { lists } = await apiSetMealLists({ status: 1 })
    this.setMealData = lists
  }
  /** E Methods **/

  /** S Life Cycle **/
  created() {
    const query: any = this.$route.query

    // โหมดแก้ไข：ข้อมูลการเริ่มต้น
    this.identity = +query.id
    if (+query.id) {
      this.getShopDetailFunc()
    }

    this.onSubmit = debounce(this.onSubmit, 2000)
    this.getSetMealLists()
  }
  /** E Life Cycle **/
}
